<template>
    <div class="container-fluid position-relative d-flex mx-auto flex-column">
        <div class="container pc-home-splash p-0 p-md-3">
            <div>
                <div class="panel-group-wrapper pc-panel-group-wrapper">
                    <div class="panel-group-mainnet">
                        <div class="panel-group-left">
                            <section class="data-wrapper">
                                <div class="card-body row home-stats mainnet-data">
                                    <section class="data-overview">
                                                                            
                                        <!-- Total Acccounts -->
                                        <DataItem :loading="loadingAccounts">                                                                                       
                                            <a href="#">
                                                <div class="data-item-left">
                                                    <img :src="require('@/assets/images/account_icon_new.webp')" alt="">
                                                    <div class="data-item-center">
                                                    <p class="m-0 panel-title">
                                                        <span>账户总数</span>
                                                    </p>
                                                    <h2 class="m-0 panel-number">
                                                        <span>{{ minTotalAcct.toLocaleString() }}</span>
                                                    </h2>
                                                    </div>
                                                </div>
                                                <div class="data-item-right">
                                                    <p class="m-0 right-24h">
                                                    <span>24h</span>
                                                    </p>
                                                    <p class="m-0 number">
                                                    <span class="green">+{{ this.ttl_newAccounts.toLocaleString() }}</span>
                                                    </p>
                                                </div>
                                            </a>                                                                                        
                                        </DataItem>
                                        
                                        <!-- TVL -->
                                        <DataItem :loading="loadingVolume">
                                            <a href="#">
                                                <div class="data-item-left">
                                                    <img :src="require('@/assets/images/tvl_icon_new.webp')" alt="">
                                                    <div class="data-item-center">
                                                        <p class="m-0 panel-title"><span>锁定总价值</span></p>
                                                        <h2 class="m-0 panel-number">$ <span>{{ this.tvl.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</span></h2>
                                                    </div>
                                                </div>
                                                <div class="data-item-right">
                                                    <p class="m-0 right-24h"><span>24h</span></p>
                                                    <p class="m-0 number"><span class="red">-1.14%</span></p>
                                                </div>
                                            </a>
                                        </DataItem>

                                        <!-- Total Transactions -->
                                        <DataItem :loading="loadingTokens">
                                            <a href="#">
                                                <div class="data-item-left">
                                                    <img :src="require('@/assets/images/transition_icon_new.webp')" alt="">
                                                    <div class="data-item-center">
                                                    <p class="m-0 panel-title">
                                                        <span>总交易量</span>
                                                    </p>
                                                    <h2 class="m-0 panel-number">
                                                        <span>{{ this.ttl_transactions.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</span>
                                                    </h2>
                                                    </div>
                                                </div>
                                                <div class="data-item-right">
                                                    <p class="m-0 right-24h">
                                                    <span>24h</span>
                                                    </p>
                                                    <p class="m-0 number">
                                                    <span class="green">+{{ this.new_transactions.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</span>
                                                    </p>
                                                </div>
                                            </a>
                                        </DataItem>

                                        <!-- Total Transfer Tokens -->
                                        <DataItem :loading="loadingTransfers">
                                            <a href="#">
                                                <div class="data-item-left">
                                                    <img :src="require('@/assets/images/transferToken_icon_new.webp')" alt="">
                                                    <div class="data-item-center">
                                                    <p class="m-0 panel-title">
                                                        <span>总传输量</span>
                                                    </p>
                                                    <h2 class="m-0 panel-number"><span>{{ trx_transfer_vol === 0 ? '$17,758,959,375,303' : trx_transfer_vol }}</span>
                                                    </h2>
                                                    </div>
                                                </div>
                                                <div class="data-item-right">
                                                    <p class="m-0 right-24h">
                                                    <span>24h</span>
                                                    </p>
                                                    <p class="m-0 number">
                                                    <span class="green">+{{ this.trx_transfer_24h }}</span>
                                                    </p>
                                                </div>
                                            </a>
                                        </DataItem>
                                    </section>

                                    <section class="bottom-data-overview bottom-data-overview-en">
                                        <div class="bottom-data-overview-item align-items-center">
                                            <a href="#!" class="tron-cursor-default">
                                            <section class="d-flex align-items-center">
                                                <span class="title">
                                                <span>当前/最大 TPS</span>
                                                </span>
                                                <span class="number">
                                                <span>
                                                    <span>{{ this.cur_tps }}</span>
                                                </span>/ <span>
                                                    <span>{{ this.max_tps }}</span>
                                                </span>
                                                </span>
                                            </section>
                                            </a>
                                        </div>
                                        <div class="bottom-data-overview-item align-items-center">
                                            <a href="#!" class="tron-cursor-default">
                                            <section class="d-flex align-items-center">
                                                <span class="title">
                                                <span>节点总数</span>
                                                </span>
                                                <span class="number">
                                                <span>{{ this.ttl_node.toLocaleString() }}</span>
                                                </span>
                                            </section>
                                            </a>
                                        </div>
                                        <div class="bottom-data-overview-item align-items-center">
                                            <a href="#!" class="tron-cursor-default">
                                            <section class="d-flex align-items-center">
                                                <span class="title">
                                                <span>合同总数</span>
                                                </span>
                                                <span class="number">
                                                <span>{{ this.ttl_contracts.toLocaleString() }}</span>
                                                </span>
                                            </section>
                                            </a>
                                        </div>
                                        <div class="bottom-data-overview-item align-items-center">
                                            <a href="#!" class="tron-cursor-default">
                                            <section class="d-flex align-items-center">
                                                <span class="title">
                                                <span>代币总数</span>
                                                </span>
                                                <span class="number">
                                                <span>{{ this.ttl_tokens.toLocaleString() }}</span>
                                                </span>
                                            </section>
                                            </a>
                                        </div>
                                    </section>
                                </div>
                            </section>
                        </div>

                        <div class="panel-group-right">
                            <section class="price-wrapper" :class="{ 'is-loading': loadingTRX }" style="position: relative;">
                                <div class="trxgroup-wrapper price-content">
                                    <div class="trxgroup-wrapper-container">
                                    <a href="#">
                                        <div class="trxgroup-header">
                                        <div class="trxgroup-logo">
                                            <div class="img">
                                            <svg class="icon tron-icon tronImg" aria-hidden="true">
                                                <use xlink:href="/static/media/icons.svg#icon-icon-tron"></use>
                                            </svg>
                                            </div>
                                            <div class="trxgroup-header-content">
                                            <div class="title">TRX</div>
                                            <div class="trxgroup-price">
                                                <span class="price-number">${{ this.trx_price }}</span>
                                                <span :class="['trxgroup-wave', isPositiveChange ? 'up' : 'down']">
                                                    <span>{{ isPositiveChange ? '+' : '-' }}</span>
                                                    <span>{{ formattedPercentChange }}</span>
                                                    <span class="arrow-img">
                                                        <i class="iconfont tron-font-size-10px" :class="isPositiveChange ? 'icon-up' : 'icon-down'"></i>
                                                    </span>
                                                </span>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="trxgroup-time">
                                            <div>
                                            <div class="market-item">
                                                <span class="trxgroup-title">市场</span>
                                                <span class="trxgroup-number">{{ this.trx_market_cap }}</span>
                                            </div>
                                            </div>
                                            <div>
                                            <div class="market-item">
                                                <span class="trxgroup-title">体积</span>
                                                <span class="trxgroup-number">{{ this.trx_market_vol }}</span>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </a>
                                    <div class="trxgroup-bottom-content">
                                        <div class="trxgroup-bt-content">
                                        <div class="trxgroup-chart">
                                            <div id="chartId_home_supply" class="echarts-dom-class" ref="chartRef"></div>                                            
                                        </div>
                                        <div class="trxgroup-freeze-content">
                                            <div class="trxgroup-freeze-data">
                                            <div class="trxgroup-title">
                                                <span>供应</span>
                                            </div>
                                            <div class="trxgroup-content-number">
                                                <a href="#">
                                                <span>{{ this.trx_supply_cap }}</span>
                                                </a>
                                            </div>
                                            </div>
                                            <div class="trxgroup-freeze-data">
                                            <div class="trxgroup-title">
                                                <span>质押</span>
                                            </div>
                                            <div class="trxgroup-content-number">
                                                <a href="#">
                                                <span> {{ this.trx_stake_cap }}</span>
                                                </a>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>

                                <div class="loading-overlay" v-if="loadingAccounts">
                                    <div class="spinner"></div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import tronAPI from '@/utils/tronAPI';
    import * as echarts from 'echarts';
    import DataItem from '@/components/DataItem.vue'

    export default {
        name: "TronSummary",
        components: {
            DataItem,
        },
        data() {
            return {
                chart: null,
                loading: false,
                tronOverview: [],
                tronHomeData: [],
                trxHolders: 0,
                newTotalAcct: 0,
                minTotalAcct: 0,
                maxTotalAcct: 0,
                maxTransactions: 0,
                intervalAcct: null, 
                chartInstance: null,

                tvl: 0,
                tvl_ratio: 0,
                ttl_newAccounts: 0,                
                ttl_transactions: 0,
                new_transactions: 0,
                cur_tps: 0,
                max_tps: 0,
                ttl_node: 0,
                ttl_contracts: 0,
                ttl_tokens: 0,

                trx_price: 0,
                trx_priceLine: [],
                
                trx_market_cap: 0,
                trx_market_vol: 0,
                trx_supply_cap: 0,
                trx_stake_cap: 0,
                trx_transfer_vol: 0,
                trx_transfer_24h: 0,
                trx_market: {},
                trx_supply: {},
                trx_stake: {},
                trx_transfer: {},
                
                loadingAccounts: true,
                loadingTransfers: true,
                loadingTokens: true,
                loadingVolume: true,
                loadingTRX: true,                
            }
        },
        async mounted() {
            await this.getOverView();                                                
        },
        computed: {
            isPositiveChange() {
                const change = parseFloat(this.trx_market.percent_change_24h);
                return change >= 0;
            },
            formattedPercentChange() {
                const val = Math.abs(parseFloat(this.trx_market.percent_change_24h));
                return `${val.toFixed(2)}%`;
            },
        },
        methods: {
            async getOverView() {
                this.loading = true;                
                try {
                    const [ trxOverView, trxHomeData ] = await Promise.all([
                        tronAPI.getTronOverview(),
                        tronAPI.getHomeData(),                    
                    ]);

                    this.tronOverview = trxOverView;
                    this.tronHomeData = trxHomeData;
                                                                                                    
                    this.cur_tps = this.tronHomeData.tps.data.currentTps;
                    this.max_tps = this.tronHomeData.tps.data.maxTps;
                    this.ttl_node = this.tronHomeData.node.total;
                    this.ttl_contracts = this.tronHomeData.statsOverview.new_account_for_one_month;
                    this.ttl_tokens = this.tronHomeData.statsOverview.avg_new_account_for_one_month;                    
                    this.trx_priceLine = this.tronHomeData.trxPriceLine;

                    const trxTransfer24 = await this.fetchTransferVol24();
                    if(trxTransfer24)
                    {
                        this.trx_transfer = trxTransfer24;
                        if(this.trx_transfer.data[1].usd_amount)                        
                            this.trx_transfer_24h = parseInt(this.trx_transfer.data[1].usd_amount).toLocaleString();
                        else
                            this.trx_transfer_24h = parseInt(this.trx_transfer.data[0].usd_amount).toLocaleString();

                        this.loadingTransfers = false;    
                    }

                    const timeLabels = this.trx_priceLine.data.map(item => {
                        const date = new Date(parseInt(item.time) * 1000);
                        return date.toLocaleString();
                    });

                    const prices = this.trx_priceLine.data.map(item => parseFloat(item.priceUsd));
                    const minPrice = Math.min(...prices);
                    const maxPrice = Math.max(...prices);
                    const buffer = 0.0005; 

                    const option = {
                        title: {
                            text: 'TRON Price Over Time',
                            left: 'center',
                            show: false
                        },
                        tooltip: {
                            trigger: 'axis',
                            formatter: params => {
                                const point = params[0];
                                return `
                                    Time: ${point.axisValue}<br/>
                                    Price: $${point.data.toFixed(6)}
                                `;
                            }
                        },
                        xAxis: {
                            type: 'category',
                            data: timeLabels,
                            name: '',
                            axisLabel: {
                                rotate: 45,
                                show: false
                            }
                        },
                        yAxis: {
                            type: 'value',
                            name: 'Price (USD)',
                            min: minPrice - buffer,
                            max: maxPrice + buffer,
                            show: false
                        },
                        series: [{
                            data: prices,
                            type: 'line',
                            smooth: true,
                            showSymbol: true,
                            lineStyle: {
                                color: '#00c4ff'
                            },
                            areaStyle: {
                                color: 'rgba(0, 196, 255, 0.2)'
                            }
                        }]
                    };

                    const chart = echarts.init(document.getElementById('chartId_home_supply'));
                    chart.setOption(option);
                    chart.resize();
                    
                    const trxMarket = await this.fetchTRXSummary();
                    if(trxMarket)
                    {
                        this.trx_market = trxMarket;
                        this.trx_price = parseFloat(this.trx_market.price_in_usd).toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 });
                        this.trx_market_cap = this.formatMarketCap(this.trx_market.market_cap);
                        this.trx_market_vol = this.formatMarketCap(this.trx_market.volume_24h);
                    }
                    const trxSupply = await this.fetchTRXSupply();
                    if(trxSupply)
                    {
                        this.trx_supply = trxSupply;
                        const tmpSupplyData = this.trx_supply.data.length - 1;
                        this.trx_supply_cap = (parseInt(this.trx_supply.data[tmpSupplyData].total_turn_over)).toLocaleString();
                    }
                    const trxStake = await this.fetchTRXStake();
                    if(trxStake)
                    {
                        this.trx_stake = trxStake;
                        this.trx_stake_cap = (parseInt(this.trx_stake.total_freeze_weight)).toLocaleString();
                        this.loadingTRX = false;
                    }
                                                            
                    
                } catch (error) {
                    console.error(error);
                } finally {
                    this.loading = false;
                    this.startIncrement();
                    this.maxTransactions = this.tronHomeData.statsOverview.data[0].totalTransaction;                
                }
            },

            startIncrement() {
                const totalAddresses = this.tronOverview.data.map(d => d.totalAddress);
                const minTotalAddress = Math.min(...totalAddresses);
                this.maxTotalAcct = Math.max(...totalAddresses);
                this.minTotalAcct = minTotalAddress;
                this.newTotalAcct = this.maxTotalAcct - minTotalAddress;

                this.intervalAcct = setInterval(() => {
                    if (this.minTotalAcct < this.maxTotalAcct) {
                        let increment = Math.floor(Math.random() * 41) + 10;
                        this.minTotalAcct = Math.min(
                            this.minTotalAcct + increment,
                            this.maxTotalAcct
                        );
                    } else {
                        clearInterval(this.interval);
                    }
                }, 5000);

                const tmpStatsOverview = this.tronHomeData.statsOverview;
                const tmpDataTotal = tmpStatsOverview.data.length - 1;
                const tmpData24H = tmpStatsOverview.data.length - 2;
                const tmpTrxLineCount = this.tronHomeData.trxPriceLine.data.length;
                
                this.ttl_newAccounts = tmpStatsOverview.data[tmpDataTotal].totalTrc20;
                this.loadingAccounts = false;

                this.loadingTokens = false;
                this.ttl_transactions = tmpStatsOverview.data[tmpDataTotal].totalTransaction;
                this.new_transactions = tmpStatsOverview.data[tmpDataTotal].newTransactionSeen;
                
                this.loadingVolume = false;
                this.tvl = this.tronHomeData.tvl.total;

            },
            handleResize() {
                this.chart.resize();
            },
            formatMarketCap(value) {
                const num = parseFloat(value);
                if (isNaN(num)) return '$0';

                if (num >= 1_000_000_000_000) {
                    return `$${(num / 1_000_000_000_000).toFixed(1)}t`;
                } else if (num >= 1_000_000_000) {
                    return `$${(num / 1_000_000_000).toFixed(1)}b`;
                } else if (num >= 1_000_000) {
                    return `$${(num / 1_000_000).toFixed(1)}m`;
                } else if (num >= 1_000) {
                    return `$${(num / 1_000).toFixed(1)}k`;
                } else {
                    return `$${num.toFixed(2)}`;
                }
            },
            formatUSD(value) {
                //if (value >= 1_000_000_000_000) return `$${(value / 1_000_000_000_000).toFixed(1)}T`;
                //if (value >= 1_000_000_000) return `$${(value / 1_000_000_000).toFixed(1)}B`;
                return value.toLocaleString();
            },
            async delayedFetch(url, delayMs) {
                await new Promise(resolve => setTimeout(resolve, delayMs));
                return axios.get(url);
            },
            async fetchTransferVolume() {
                try {                    
                    const url = `https://apilist.tronscanapi.com/api/transfer/statistics`;

                    const response = await this.delayedFetch(url, 1500);                    
                    return response.data;
                } catch (err) {
                    this.error = 'Failed to fetch TRX Stake';
                    console.error(err);
                    return null;
                }
            },
            async fetchTransferVol24() {                
                try {                    
                    const url = `https://apilist.tronscanapi.com/api/tokenTransfer/analysis?token=&days=2`;

                    const response = await this.delayedFetch(url, 1500);                    
                    return response.data;
                } catch (err) {
                    this.error = 'Failed to fetch TRX Stake';
                    console.error(err);
                    return null;
                }
            },
            async fetchTRXSummary() {
                try {
                    const response = await this.delayedFetch('https://apilist.tronscanapi.com/api/token/price?token=trx', 1500);                    
                    return response.data;                    
                } catch (err) {
                    this.error = 'Failed to fetch TRX Summary';
                    console.error(err);
                }
            },
            async fetchTRXSupply() {
                try {
                    const response = await this.delayedFetch('https://apilist.tronscanapi.com/api/turnover?from=issuance&type=0&start=1575129600000&end=1744572425266&size=10',1500);                    
                    return response.data;
                } catch (err) {
                    this.error = 'Failed to fetch TRX Summary';
                    console.error(err);
                }
            },
            async fetchTRXStake() {
                try {                    
                    const endDate = new Date();                    
                    const startDate = new Date();
                    startDate.setDate(endDate.getDate() - 6);
                    
                    const formatDate = (date) =>
                    date.toISOString().split('T')[0];

                    const start_day = formatDate(startDate);
                    const end_day = formatDate(endDate);

                    const url = `https://apilist.tronscanapi.com/api/freezeresource?start_day=${start_day}&end_day=${end_day}`;

                    const response = await this.delayedFetch(url, 1500);                    
                    return response.data;
                } catch (err) {
                    this.error = 'Failed to fetch TRX Stake';
                    console.error(err);
                    return null;
                }
            },
        }        
    }

</script>

<style scoped>
    .loading-overlay {
        position: absolute;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.6);
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
    }

    .spinner {
        border: 4px solid #eee;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        width: 28px;
        height: 28px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
</style>
